// extracted by mini-css-extract-plugin
export default {"root":"CameraPermissionStep_root__HG1K8","actions":"CameraPermissionStep_actions__9SMfS"};